import { useState } from 'react';

export default function ContactoSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const whatsappNumber = '56994347092';
  const instagramUrl = 'https://instagram.com/lacasonadedonjuan';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);
      
      const response = await fetch('https://readdy.ai/api/form/d658l99of4o2fjfo9f4g', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', telefono: '', mensaje: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contacto" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-stone-800 mb-4">
            ¿Nos Visitas Hoy?
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Estamos aquí para atenderte. Contáctanos por tu medio preferido.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Botones de Contacto Rápido */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-stone-800 mb-6">Contacto Directo</h3>
            
            <a
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hola, me gustaría hacer una consulta sobre la cafetería')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 bg-green-600 hover:bg-green-700 text-white p-6 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className="ri-whatsapp-line text-3xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-1">WhatsApp</h4>
                <p className="text-sm text-white/90">Respuesta rápida y directa</p>
              </div>
              <i className="ri-arrow-right-line text-2xl ml-auto"></i>
            </a>

            <a
              href={`tel:+${whatsappNumber}`}
              className="flex items-center gap-4 bg-stone-700 hover:bg-stone-800 text-white p-6 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className="ri-phone-line text-3xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-1">Llamar</h4>
                <p className="text-sm text-white/90">+56 9 9434 7092</p>
              </div>
              <i className="ri-arrow-right-line text-2xl ml-auto"></i>
            </a>

            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white p-6 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className="ri-instagram-line text-3xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-lg mb-1">Instagram</h4>
                <p className="text-sm text-white/90">@lacasonadedonjuan</p>
              </div>
              <i className="ri-arrow-right-line text-2xl ml-auto"></i>
            </a>
          </div>

          {/* Formulario */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-2xl font-bold text-stone-800 mb-6">Envíanos un Mensaje</h3>
            
            <form id="contacto-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-5">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-stone-700 mb-2">
                    Nombre *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-stone-200 rounded-xl focus:border-amber-600 focus:outline-none transition-colors text-sm"
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-stone-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-stone-200 rounded-xl focus:border-amber-600 focus:outline-none transition-colors text-sm"
                    placeholder="+56 9 1234 5678"
                  />
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-semibold text-stone-700 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 border-2 border-stone-200 rounded-xl focus:border-amber-600 focus:outline-none transition-colors resize-none text-sm"
                    placeholder="¿En qué podemos ayudarte?"
                  ></textarea>
                  <p className="text-xs text-stone-500 mt-1">Máximo 500 caracteres</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-amber-600 hover:bg-amber-700 disabled:bg-stone-300 text-white px-6 py-4 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      Enviar Mensaje
                    </>
                  )}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border-2 border-green-200 text-green-800 px-4 py-3 rounded-xl text-sm flex items-center gap-2">
                    <i className="ri-check-line text-xl"></i>
                    ¡Mensaje enviado! Te contactaremos pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border-2 border-red-200 text-red-800 px-4 py-3 rounded-xl text-sm flex items-center gap-2">
                    <i className="ri-error-warning-line text-xl"></i>
                    Error al enviar. Intenta por WhatsApp.
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
